/* eslint-disable */
export default {
  forward: 'Desviar',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
